module.exports = __webpack_public_path__ + "static/Megazone-95e50e122e43e4b0535d423f22be0399.mp4";